import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export default function AdminBusinessImpersonate(){

  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { startImpersonation } = useAuth();

  const businessId = params.get("business");
  const resellerId = params.get("reseller");

  const [profile, setProfile] = useState(null);

  useEffect(()=>{

    const load = async ()=> {

      if(businessId){
        const snap = await getDoc(doc(db, "businesses", businessId));
        setProfile(snap.exists() ? snap.data() : {});
      }

      if(resellerId){
        const snap = await getDoc(doc(db, "resellers", resellerId));
        setProfile(snap.exists() ? snap.data() : {});
      }

    };

    load();

  }, [businessId, resellerId]);


  const handleImpersonate = () => {
    if (businessId) {
      startImpersonation("business", businessId);
      navigate("/business/dashboard");
    }

    if (resellerId) {
      startImpersonation("reseller", resellerId);
      navigate("/reseller/dashboard");
    }
  };

  return(
    <div className="min-h-screen bg-gray-950 text-white px-6 py-10">

      <h1 className="text-3xl font-bold mb-6">Impersonation Mode</h1>

      {businessId && (
        <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">
          <h2 className="text-2xl font-semibold">
            Business: {profile?.businessName || businessId}
          </h2>

          <button
            onClick={handleImpersonate}
            className="bg-yellow-500 text-black px-4 py-2 mt-6 rounded"
          >
            Enter Business Dashboard
          </button>
        </div>
      )}

      {resellerId && (
        <div className="bg-gray-900 p-6 rounded-xl border border-blue-800 mt-6">
          <h2 className="text-2xl font-semibold">
            Reseller: {profile?.name || resellerId}
          </h2>

          <button
            onClick={handleImpersonate}
            className="bg-blue-500 text-white px-4 py-2 mt-6 rounded"
          >
            Enter Reseller Dashboard
          </button>
        </div>
      )}

    </div>
  );
}
